import { render, staticRenderFns } from "./TransactionNotesDisplay.yaml?vue&type=template&id=1f9e131c&component"
import script from "./TransactionNotesDisplay.yaml?vue&type=script&lang=ts&component"
export * from "./TransactionNotesDisplay.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports